import link from './link'
import { richTextFields } from './_shared'

export const fields = `
  _type,
  timeZone,
  location,
  links[]{${link.fields}},
  instagramLink,
  email,
  preloader {
    text[]{${richTextFields}},
  }
`

export const fragment = (name = 'navigation') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
